<knx-alert [class]="userClass()">
  <ng-icon name="lucideInfo" />
  <div knxAlertDescription>
    <p class="mb-1">{{ 'app.passwordPolicy.message' | translate }}</p>
    <ul class="list-inside list-disc">
      <li>{{ 'app.passwordPolicy.requirements.length' | translate }}</li>
      <li>{{ 'app.passwordPolicy.requirements.number' | translate }}</li>
      <li>{{ 'app.passwordPolicy.requirements.special' | translate }}</li>
      <li>{{ 'app.passwordPolicy.requirements.upper' | translate }}</li>
      <li>{{ 'app.passwordPolicy.requirements.lower' | translate }}</li>
    </ul>
  </div>
</knx-alert>
